import { IUpdateFornecedorAvaliacaoUseCase } from "../../../presentation/useCases/update/update_fornecedor_avaliacao_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateFornecedorAvaliacaoUseCase
 */

export class UpdateFornecedorAvaliacaoUseCase implements IUpdateFornecedorAvaliacaoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateFornecedorAvaliacao(
    idFornecedor: number,
    idAvaliacaoFornecedor: number,
    avaliadoPor: number,
    data: Date,
    observacao: string,
    items: {
      idItemAvaliacaoFornecedor: number;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.repository.updateFornecedorAvaliacao(
      idFornecedor,
      idAvaliacaoFornecedor,
      avaliadoPor,
      data,
      observacao,
      items,
    );
  }
}
